import {
  DISPLAY_STYLE_HEADER,
  DISPLAY_STYLE_SHADED,
  DISPLAY_STYLE_BOLD,
  DISPLAY_STYLE_CENTER,
  DISPLAY_STYLE_LEFT,
  DISPLAY_STYLE_RIGHT,
  DISPLAY_STYLE_MULTI_CHECKBOX_NEW_LINES,
  DISPLAY_STYLE_RIGHT_ALIGN_STRING,
} from "components/Shared/MGridForm";
import {
  DATA_TYPE_STRING,
  DATA_TYPE_CHECKBOX,
  DATA_TYPE_RADIO,
  DATA_TYPE_SPLIT_RADIO,
  DATA_TYPE_DROPDOWN,
  DATA_TYPE_MULTI_LINE_STRING,
  DATA_TYPE_DATE,
  DATA_TYPE_TOOLTIP,
} from "typeConstants/dataTypes";

//Returns true if the checkbox is checked.
const isChecked = (data, field) => typeof data[field] === "string" ? data[field].toLowerCase().startsWith("t") : data[field];

/*
Returns true if the conditions have been met to enable the entire Cost Approach section
By default, this section is disabled when form first loads
*/
const costApproachEnabled = data => {
  return data["cost-approach-required"] === "1" || isChecked(data, "cost-approach-mandated");
};

/*
Returns true if the conditions have been met to enable the entire Income section
By default, this section is disabled when form first loads
*/
const incomeApproachEnabled = data => {
  return data["income-approach-required"] === "1";
};

const comparableEnabled = (data, field) => {
  let i = parseInt(field.split("-")[2]);
  return i <= data["comparable-count"] && data[`comparable-enabled-${i}`];
};

//little hack for the title controls because they dont have sources
const comparableTitleEnabled = num => data => comparableEnabled(data, `--${num}`);

export const getEnabledKvpForElectricalServiceRepeat = i => {
  let enabledKvp = [];
  enabledKvp[`off-grid-service-${i}`] = data => ["Solar", "Generator", "Wind", "Hydro Electric"].includes(data[`electrical-service-2-${i}`]);
  enabledKvp[`solar-panel-ownership-${i}`] = data => data[`electrical-service-2-${i}`] === "Solar";
  return enabledKvp;
};

const heatingFields = ["FN-177", "FN-178", "FN-179", "FN-180"];
const heatingFilter = () => {
  return (field) => {
    return selectOneFilter(heatingFields, field).map(source => [source, { checked: false }]);
  };
};

const foundationFields = ["FN-147", "FN-148", "FN-150"];
const foundationNoneField = ["FN-149"];
const foundationFilter = () => {

  return (selectedField) => {
    return noneFilter(foundationFields, selectedField, foundationNoneField).map(source => [source, { checked: false }]);
  };
};

const atticFields = ["FN-171", "FN-172", "FN-173", "FN-174", "FN-175", "FN-176"];
const atticNoneField = ["FN-170"];
const atticFilter = () => {
  return (selectedField) => {
    return noneFilter(atticFields, selectedField, atticNoneField).map(source => [source, { checked: false }]);
  };
};

const carStorageFields = ["FN-202", "FA-209-1", "FA-210-1", "FA-211-1", "FN-207"];
const carStorageNoneField = ["FN-201"];
const carStorageFilter = () => {
  return (selectedField) => {
    return noneFilter(carStorageFields, selectedField, carStorageNoneField).map(source => [source, { checked: false }]);
  };
};

const selectOneFilter = (myfields, currentSource) => {
  return myfields.filter((obj) => obj != currentSource.source);
};

const noneFilter = (myFields, selectedField, noneFilter) => {

  if (myFields.includes(selectedField.source)) return noneFilter;

  return myFields;
};


const customValidator = (data, field) => {
  //foundation
  if (field === "FN-147" || field === "FN-148" || field === "FN-149" || field === "FN-150") {
    if (isChecked(data, "FN-147") || isChecked(data, "FN-148") || isChecked(data, "FN-149") || isChecked(data, "FN-150")) return null;

    return "A foundation must be selected(click save to refresh)";
  }

  if (field === "FN-201" || field === "FN-202" || field === "FA-209-1" || field === "FA-210-1" || field === "FA-211-1" || field === "FN-207") {
    if (isChecked(data, "FN-201") || isChecked(data, "FN-202") || isChecked(data, "FA-209-1") || isChecked(data, "FA-210-1") || isChecked(data, "FA-211-1") || isChecked(data, "FN-207")) return null;

    return "A car storage must be selected(click save to refresh)";
  }

  if (field === "FN-170" || field === "FN-171" || field === "FN-172" || field === "FN-173" || field === "FN-174" || field === "FN-175" || field === "FN-176") {
    if (isChecked(data, "FN-170") || isChecked(data, "FN-171") || isChecked(data, "FN-172") || isChecked(data, "FN-173") || isChecked(data, "FN-174") || isChecked(data, "FN-175") || isChecked(data, "FN-176")) return null;

    return "An attic field must be selected(click save to refresh)";
  }


  //Heating
  if (field === "FN-177" || field === "FN-178" || field === "FN-179" || field === "FN-180") {
    if (isChecked(data, "FN-177") || isChecked(data, "FN-178") || isChecked(data, "FN-179") || isChecked(data, "FN-180")) return null;

    return "If no heating, check Other and indicate None in description.";
  }

  // Cooling
  if (field === "FN-183|FN-184|FN-185") {
    if (data["FN-183|FN-184|FN-185"]) return null;

    return "If no cooling, then check “Other” & indicate “None” in description.";
  }


  if (field === "FA-164-2") {
    if (typeof data["FA-164-1"] !== "string") return;

    if (typeof data[field] !== "string") return "A valid selection is required";

    if (data["FA-164-1"].toLowerCase().startsWith("n")
      && !data[field].toLowerCase().startsWith("n"))
      return "A valid selection is required";

    if (data["FA-164-1"].toLowerCase().startsWith("y")
      && data[field].toLowerCase().startsWith("n"))
      return "A valid selection is required";
  }

  // Number of cars validation
  switch (field) {
    case "FN-203":
      if (isChecked(data, "FN-202") && !numberGreaterThanZero(data, field, data[field]))
        return "Driveway Checked. # of cars must be greater than zero";
      else if (!isChecked(data, "FN-202") && (data[field] != "0"))
        return "Driveway Not Checked. # of cars must equal zero";
      return null;
    case "FA-209-2":
      if (isChecked(data, "FA-209-1") && !numberGreaterThanZero(data, field, data[field]))
        return "Att. Garage Checked. # of cars must be greater than zero";
      else if (!isChecked(data, "FA-209-1") && (data[field] != "0"))
        return "Att. Garage Not Checked. # of cars must equal zero";
      return null;
    case "FA-210-2":
      if (isChecked(data, "FA-210-1") && !numberGreaterThanZero(data, field, data[field]))
        return "Det. Garage Checked. # of cars must be greater than zero";
      else if (!isChecked(data, "FA-210-1") && (data[field] != "0"))
        return "Det. Garage Not Checked. # of cars must equal zero";
      return null;
    case "FA-211-2":
      if (isChecked(data, "FA-211-1") && !numberGreaterThanZero(data, field, data[field]))
        return "Built-in Garage Checked. # of cars must be greater than zero";
      else if (!isChecked(data, "FA-211-1") && (data[field] != "0"))
        return "Built-in Garage Not Checked. # of cars must equal zero";
      return null;
    case "FN-208":
      if (isChecked(data, "FN-207") && !numberGreaterThanZero(data, field, data[field]))
        return "Carport Checked. # of cars must be greater than zero";
      else if (!isChecked(data, "FN-207") && (data[field] != "0"))
        return "Carport Not Checked. # of cars must equal zero";
      return null;
    default:
      break;
  }

  // Fireplace/Woodstove validation
  switch (field) {
    case "FN-188":
      if (isChecked(data, "FN-187") && !numberGreaterThanZero(data, field, data[field]))
        return "Fireplace Checked. # must be greater than zero";
      else if (!isChecked(data, "FN-187") && (data[field] != "0"))
        return "Fireplace Not Checked. # must equal zero";
      return null;
    case "FN-194":
      if (isChecked(data, "FN-193") && !numberGreaterThanZero(data, field, data[field]))
        return "Woodstove Checked. # must be greater than zero";
      else if (!isChecked(data, "FN-193") && (data[field] != "0"))
        return "Woodstove Not Checked. # must equal zero";
      return null;
    default:
      break;
  }

  // None Handling
  if (field === "FN-117") {
    return data["FN-117"] === "" && data["FN-118|FN-119"] !== "Unknown"
      ? "Field is required unless None is selected"
      : null;
  }
  if (field === "FN-120") {
    return data["FN-120"] === "" && data["FN-121|FN-122"] !== "Unknown"
      ? "Field is required unless None is selected"
      : null;
  }

  switch (field) {
    case "FN-190":
      if (isChecked(data, "FN-189") && data["FN-190"] === "None") return "Patio/Deck checked. Description cannot be equal to none.";
      else if (isChecked(data, "FN-189") && data["FN-190"] === "") return "Patio/Deck checked. Description required.";
      else return null;
    case "FN-192":
      if (isChecked(data, "FN-191") && data["FN-192"] === "None") return "Pool checked. Description cannot be equal to none.";
      else if (isChecked(data, "FN-191") && data["FN-192"] === "") return "Pool checked. Description required.";
      else return null;
    case "FN-196":
      if (isChecked(data, "FN-195") && data["FN-196"] === "None") return "Fence checked. Description cannot be equal to none.";
      else if (isChecked(data, "FN-195") && data["FN-196"] === "") return "Fence checked. Description required.";
      else return null;
    case "FN-198":
      if (isChecked(data, "FN-197") && data["FN-198"] === "None") return "Porch checked. Description cannot be equal to none.";
      else if (isChecked(data, "FN-197") && data["FN-198"] === "") return "Porch checked. Description required.";
      else return null;
    case "FN-200":
      if (isChecked(data, "FN-199") && data["FN-200"] === "None") return "Other checked. Description cannot be equal to none.";
      else if (isChecked(data, "FN-199") && data["FN-200"] === "") return "Other checked. Description required.";
      else return null;
    default:
      break;
  }

  if (field === "FN-107") {
    if (data["FN-105|FN-106"] === "NonPublic" && data[field] === "None") {
      return "Other checked, Cannot equal None";
    } else if (data["FN-105|FN-106"] && !data[field]) {
      return "Field is Required";
    } else return null;
  }

  // FN-182
  if (field === "FN-182") {
    if (!isChecked(data, "FN-177") && !isChecked(data, "FN-178") && !isChecked(data, "FN-179")) {
      if (data["FN-182"] !== "None" && isChecked(data, "FN-180") && data["FN-181"] === "None") {
        return "If no heating, indicate None in description.";
      } else if (data["FN-182"] === "") return "Field is Required";
      else return null;
    } else if (!isChecked(data, "FN-180") && data["FN-182"] === "None") {
      return "Other is not checked, Description cannot be equal None";
    } else return null;
  }

  if (field === "FN-186") {
    return data["FN-183|FN-184|FN-185"] === "Other" && !data[field]
      ? "Cooling: If no cooling, then check “Other” & indicate “None” in description"
      : null;
  }

  // ADU Validation
  switch (field) {
    case "ADU-03":
    case "ADU-05":
    case "ADU-06":
    case "ADU-07":
    case "ADU-08":
      return data[field] === "" && data["ADU-01"] === "Yes"
        ? "Field is required"
        : null;
    case "ADU-07A":
      return data[field] === "" && data["ADU-07"] === "Yes"
        ? "Field is required"
        : null;
    case "ADU-08A":
      return data[field] === "" && data["ADU-08"] === "No"
        ? "Field is required"
        : null;
    default:
      break;
  }

  if (field === "FA-209" || field === "FA-210" || field === "FA-211") {
    return (isChecked(data, "FN-207") && !data["FA-209"] && !data["FA-210"] && !data["FA-211"])
      ? "Field is Required"
      : null;
  }

  if (field === "FN-133-1|FN-133-2|FN-133-3") {
    return data["FN-131|FN-132"] === "true" && !data[field]
      ? "Field is Required"
      : null;
  }

  if (field === "FN-233-1|FN-233-2|FN-233-3") {
    return data["FN-231|FN-232"] === "true" && !data[field]
      ? "Field is Required"
      : null;
  }

  if (field === "FN-236-1|FN-236-2|FN-236-3") {
    return data["FN-234|FN-235"] === "false" && !data[field]
      ? "Field is Required"
      : null;
  }

  if (field === "FN-19") {
    const regex = /\d/;
    if (data[field] === "") return "Map Reference field is required";
    if (data[field].trim() === "0,0") return "Map Reference field is invalid";
    if (!regex.test(data[field])) return "Map Reference field must contain at least one number";
    return null;
  }

  // Purchase Type Validations
  switch (field) {
    case "FN-43|FN-44":
    case "FN-45":
    case "FN-46-1|FN-46-2":
    case "FN-47":
    case "FA-48":
    case "FN-49|FN-50":
    case "FN-51":
    case "FN-52|FN-53":
    case "FN-54":
    case "FN-56-1|FN-56-2|FN-56-3": {
      if (data[field] === "" && data["FN-33|FN-34|FN-35"] === "Purchase") return "Field is Required";
      else return null;
    }
  }

  if (field === "FN-54" || field === "FN-56-1|FN-56-2|FN-56-3") {
    return data[field] === "" && data["FN-52|FN-53"] === "true"
      ? "Field is Required"
      : null;
  }

  if (field === "FN-229") {
    if (data["FN-229"] === "" && (data["FN-228"] === "Updated" || data["FN-228"] === "Remodeled")) return "Kitchen (Performed within last) Required";
    return null;
  }

  if (field === "FN-229-1") {
    if (data["FN-229-1"] === "" && (data["FN-228-1"] === "Updated" || data["FN-228-1"] === "Remodeled")) return "Bathroom (Performed within last) Required";
    return null;
  }

  if (field === "FN-226") {
    if (!data["FN-226"]) return "Has any material work been done in the kitchen or bathrooms of the residence within the last 15 years? Required";
    if (data["FN-226"] === "true" && data["FN-228"] === "NotUpdated" && data["FN-228-1"] === "NotUpdated"){
      return 'Both Kitchen & Bathroom are "Not Updated". Has any material work been done in the kitchen or bathrooms of the residence within the last 15 years? must be "No"';
    }
    return null;
  }

};

/*
Some fields should not be enabled until certain questions have been answered
Even then, said questions may need to be answered in specific ways
By default, these conditionally-enabled fields are disabled when the form first loads
this method enables the fields when necessary
*/
const shouldBeEnabled = (data, field) => {
  if (field === "FN-32") {
    return data["FN-29|FN-30|FN-31"] === "Other";
  }
  if (field === "FN-36") {
    return data["FN-33|FN-34|FN-35"] === "Other";
  }
  if (field === "FN-54" || field === "FN-56-1|FN-56-2|FN-56-3") {
    return data["FN-52|FN-53"] === "true";
  }
  if (field === "FA-92-3") {
    return data["FA-92-2"] === "Other";
  }
  if (field === "FA-92-5") {
    return data["FA-92-4"] === "Other";
  }
  if (field === "FN-101") {
    return data["FN-97|FN-98|FN-99|FN-100"] === "Illegal";
  }
  if (field === "FN-104-1|FN-104-2" || field === "Highest And Best Use If No Describe Label") {
    return data["FN-102|FN-103"] === "false";
  }
  if (field === "FN-107") {
    return data["FN-105|FN-106"] === "NonPublic";
  }
  if (field === "FN-110") {
    return data["FN-108|FN-109"] === "NonPublic";
  }
  if (field === "FN-113") {
    return data["FN-111|FN-112"] === "NonPublic";
  }
  if (field === "FN-116") {
    return data["FN-114|FN-115"] === "NonPublic";
  }
  if (field === "FN-117") {
    return data["FN-118|FN-119"] !== "Unknown";
  }
  if (field === "FN-120") {
    return data["FN-121|FN-122"] !== "Unknown";
  }
  if (field === "FN-130") {
    return data["FN-128|FN-129"] === "false";
  }
  if (field === "FA-164-2") {
    return data["FA-164-1"] === "Yes";
  }
  if (field === "FN-171" || field === "FN-172" || field === "FN-173" || field === "FN-174" || field === "FN-175" || field === "FN-176") {
    return !isChecked(data, "FN-170");
  }
  if (field === "FN-181") {
    return isChecked(data, "FN-180");
  }
  if (field === "FN-186") {
    return data["FN-183|FN-184|FN-185"] === "Other";
  }
  if (field === "FN-200") {
    return isChecked(data, "FN-199");
  }
  if (field === "FN-194") {
    return isChecked(data, "FN-193");
  }
  if (field === "FN-188") {
    return isChecked(data, "FN-187");
  }
  if (field === "FN-196") {
    return isChecked(data, "FN-195");
  }
  if (field === "FN-190") {
    return isChecked(data, "FN-189");
  }
  if (field === "FN-198") {
    return isChecked(data, "FN-197");
  }
  if (field === "FN-192") {
    return isChecked(data, "FN-191");
  }
  if (field === "FN-203" || field === "FN-204") {
    return (isChecked(data, "FN-202") && !isChecked(data, "FN-201"));
  }
  if (field === "FN-206") {
    return isChecked(data, "FN-205");
  }
  if (field === "FN-208" || field === "FA-209" || field === "FA-210" || field === "FA-211") {
    return (isChecked(data, "FN-207") && !isChecked(data, "FN-201"));
  }
  if (field === "FA-209-2") {
    return (isChecked(data, "FA-209-1") && !isChecked(data, "FN-201"));
  }
  if (field === "FA-210-2") {
    return (isChecked(data, "FA-210-1") && !isChecked(data, "FN-201"));
  }
  if (field === "FA-211-2") {
    return (isChecked(data, "FA-211-1") && !isChecked(data, "FN-201"));
  }
  if (field === "FN-228" || field === "FN-228-1") {
    return data["FN-226"] === "true";
  }
  if (field === "FN-229") {
    return (data["FN-226"] === "true" && (data["FN-228"] === "Updated" || data["FN-228"] === "Remodeled"));
  }
  if (field === "FN-229-1") {
    return (data["FN-226"] === "true" && (data["FN-228-1"] === "Updated" || data["FN-228-1"] === "Remodeled"));
  }
  if (field === "FN-369-1|FN-369-2|FN-369-3") {
    return data["FN-367|FN-368"] === "false";
  }

  let pudSectionRequired = isChecked(data, "FN-25");
  if (field === "FN-441") {
    // SD-15046 Always enable the HOA - Name of Association
    return true;
  }
  if (field === "FN-436|FN-437" || field === "FN-438|FN-439" ||
    field === "FN-441" || field === "FN-442" || field === "FN-443" ||
    field === "FN-444" || field === "FN-445" || field === "FN-446" || field === "FN-447" ||
    field === "FN-448|FN-449" || field === "FN-451|FN-452" || field === "FN-453" ||
    field === "FN-454|FN-455" || field === "FN-457|FN-458" || field === "FN-460" ||
    field === "Pud Section Label") {
    return pudSectionRequired;
  }
  if (field === "FN-25_Comments") {
    // SD-15046 Only show if the field exists and HOA Amount is > 0
    return (!pudSectionRequired) && data["FN-25_Comments"] !== undefined && numberGreaterThanZero(data, field, data["FN-26"]);
  }
  if (field === "FN-450") {
    return (pudSectionRequired && (data["FN-448|FN-449"] === "true"));
  }
  if (field === "FN-456-1|FN-456-2|FN-456-3" || field === "Pud Completion Status Label") {
    return (pudSectionRequired && data["FN-454|FN-455"] === "false");
  }
  if (field === "FN-459-1|FN-459-2" || field === "Pud Rental Terms Label") {
    return (pudSectionRequired && data["FN-457|FN-458"] === "true");
  }
  if (field === "cost-approach-required") {
    return !isChecked(data, "cost-approach-mandated");
  }
  if (field === "present-land-use-other") {
    return !!data["FN-85"];
  }
  if (["FN-125", "FN-126", "FN-127"].includes(field)) {
    return data["FN-123|FN-124"] === "true";
  }

  // ADU Field Enabling
  switch (field) {
    case "ADU-01":
      return data["FN-134|FN-135"] === "true";
    case "ADU-03":
    case "ADU-05":
    case "ADU-06":
    case "ADU-07":
    case "ADU-08":
      return data["ADU-01"] === "Yes";
    case "ADU-02":
      return data["ADU-01"] === "No";
    case "ADU-03A":
      return data["ADU-03"] === "Yes";
    case "ADU-04":
      return data["ADU-03"] === "No";
    case "ADU-04A":
      return data["ADU-04"] === "Yes";
    case "ADU-07A":
      return data["ADU-07"] === "Yes";
    case "ADU-08A":
      return data["ADU-08"] === "No";
    case "ADU-10":
      return false;
    case "TOOLTIP-ADU-01":
      return data["ADU-01"] === "Yes";
    case "TOOLTIP-ADU-02A":
      return data["ADU-02"] === "Yes";
    case "TOOLTIP-ADU-02B":
      return data["ADU-02"] === "No";
    default:
      break;
  }

  if (field === "FN-19A") {
    return false;
  }

  return true;
};

const shouldBeVisible = (data, field) => {

  if (field === "FN-19A") {
    if (data[field] !== "") {
      return true;
    } else return false;
  }

  switch (field) {
    case "ADU-01":
    case "ADU-03":
    case "ADU-03A":
    case "ADU-05":
    case "ADU-06":
    case "ADU-07":
    case "ADU-07A":
    case "ADU-08":
    case "ADU-08A":
    case "ADU-10":
      return data["FN-134|FN-135"] === "true";
    case "TOOLTIP-ADU-01A":
      return data["ADU-01"] === "Yes" && data["FN-134|FN-135"] === "true";
    case "TOOLTIP-ADU-01B":
      return data["ADU-01"] === "No" && data["FN-134|FN-135"] === "true";
    case "TOOLTIP-ADU-03":
      return data["ADU-03"] === "No" && data["FN-134|FN-135"] === "true";
    case "TOOLTIP-ADU-08":
      return data["ADU-08"] === "No" && data["FN-134|FN-135"] === "true";
    case "FN-25_Comments":
      // SD-15046 Only show if the new field exists
      return (!isChecked(data, "FN-25")) && data["FN-25_Comments"] !== undefined && numberGreaterThanZero(data, field, data["FN-26"]);
    default:
      return false;
  }
};

//should be applied to any non-date fields that are required for submission
const fieldRequiredValidator = (data, field, value) => !value;

//should be applied to any date fields that are required for submission
const dateRequiredValidator = (data, field, value) => !value || value === "//";

//whole number required validator
const wholeNumberRequiredValidator = (data, field, value) => {
  if (parseInt(value) == value) return null;
  else return "This field is required. If none, enter 0.";
};

//Number required validator
const numberRequiredValidator = (data, field, value) => {
  if (value === null || value === "") return null;
  if (!isNaN(value)) return null;
  else return "Field must be a number";
};

const numberGreaterThanZero = (data, field, value) => {
  if (value === null || value === "") return false;
  if (isNaN(value)) return false;
  if (parseInt(value) <= 0) return false;
  else return true;
};

const percentageRequiredValidator = (data, field, value) => {
  if (wholeNumberRequiredValidator(data, field, value) == null && value >= 0 && value <= 100) return null;
  else return "Field must be a whole number between 0 and 100";
};

const wholeNumberRequiredOrUnkValidator = (data, field, value) => {
  let message = wholeNumberRequiredValidator(data, field, value);
  if (message && value.toLowerCase() !== "unk") return "Field must be a whole number or Unk";
  return null;
};

const stringLengthValidator = len => (data, field, value) => {
  if (!value) return null;
  if (value.length <= len) return null;
  else return `Max length: ${len} characters`;
};

const combineValidator = (...validators) => {
  return (...params) => {
    for (const validator of validators) {
      let validation = validator(...params);
      if (validation) return validation;
    }
    return false;
  };
};

const presentLandUseFields = ["FN-81", "FN-82", "FN-83", "FN-84", "FN-85", "present-land-use-other"];
const presentLandUseValidator = (data) => {
  let total = [data["FN-81"], data["FN-82"], data["FN-83"], data["FN-84"], data["FN-85"]].reduce((a, c) => !c || isNaN(c) ? a : a + +c, 0);
  if (total !== 100) return `Present Land Use should be 100% but is ${total}%`;
  else return null;
};

const reportDateValidator = (data, field, value) => {
  if (!value) return null;

  if (data["validate-report-dates"]) {
    // If checked, this is an update to an appraisal and dates don't need to match
    if (data["signature-date-update"] && data["signature-date-update"] === "1") return null;
    // If this case doesn't have the updated disclosure form with the field above to override, we shouldn't validate
    if (data["signature-date-update"] === undefined) return null;

    let signatureDate = data["FN-481"];
    let effectiveDate = data["FN-482"];
    if (value !== signatureDate || value !== effectiveDate) {
      return "Market value as of date must match signature and effective date in Disclosure section";
    }
  }
  return null;
};

const screenFields = ["FA-164-1", "FA-164-2"];
export const get1004pFormValidationGroups = [screenFields, presentLandUseFields, heatingFields, foundationFields.concat(foundationNoneField), atticFields.concat(atticNoneField), carStorageFields.concat(carStorageNoneField),];

export default [
  [
    { label: "The purpose of this summary appraisal report is to provide the lender/client with an accurate, and adequately supported, opinion of the market value of the subject property." }
  ],
  [
    { label: "Subject", style: { className: DISPLAY_STYLE_HEADER } }
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Property Address", source: "FN-7", width: 50, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "City", source: "FN-8", width: 25, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "State", source: "FN-9", width: 10, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "Zip Code", source: "FN-10", hasValidationError: fieldRequiredValidator },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Borrower", source: "FA-11-1", width: 22 },
    { dataType: DATA_TYPE_STRING, source: "FA-11-2", width: 15 },
    { dataType: DATA_TYPE_STRING, label: "Owner of Public Record", source: "FN-12", width: 38, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "County", source: "FN-13", hasValidationError: fieldRequiredValidator },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Legal Description", source: "FN-14", hasValidationError: fieldRequiredValidator }
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Assessor's Parcel #", source: "FN-15", width: 50, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "Tax Year", source: "FN-16", width: 25, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "R.E. Taxes $", source: "FN-17", hasValidationError: fieldRequiredValidator }
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Neighborhood Name", source: "FN-18", width: 50 },
    { dataType: DATA_TYPE_STRING, label: "Map Reference", source: "FN-19", width: 25, hasValidationError: customValidator },
    { dataType: DATA_TYPE_STRING, label: "Census Tract", source: "FN-20", hasValidationError: fieldRequiredValidator }
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Map Reference Additional Comment", source: "FN-19A", enabled: shouldBeEnabled, visible: shouldBeVisible, width: 100 },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Occupant", source: "FN-21|FN-22|FN-23", width: 37, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: {
        options: [{ label: "Owner", value: "OwnerOccupied" }, { label: "Tenant", value: "TenantOccupied" }, { label: "Vacant", value: "Vacant" }]
      }
    },
    { dataType: DATA_TYPE_STRING, label: "Special Assessments $", source: "FN-24", width: 28, hasValidationError: wholeNumberRequiredValidator },
    { dataType: DATA_TYPE_CHECKBOX, label: "PUD", source: "FN-25", width: 8 },
    { dataType: DATA_TYPE_STRING, label: "HOA $", source: "FN-26", width: 8, hasValidationError: wholeNumberRequiredValidator },
    {
      dataType: DATA_TYPE_RADIO, source: "FN-27|FN-28", dataTypeOptions: {
        options: [{ label: "per year", value: "Annually" }, { label: "per month", value: "Monthly" }]
      }
    }
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, label: "HOA present but PUD not selected. Please Elaborate", source: "FN-25_Comments", enabled: shouldBeEnabled, visible: shouldBeVisible, hasValidationError: fieldRequiredValidator }
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Property Rights Appraised", source: "FN-29|FN-30|FN-31", width: 44.25, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: {
        options: [{ label: "Fee Simple", value: "FeeSimple" }, { label: "Leasehold", value: "Leasehold" }, { label: "Other (describe)", value: "Other" }]
      }
    },
    { dataType: DATA_TYPE_STRING, source: "FN-32", enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Assignment Type", source: "FN-33|FN-34|FN-35", width: 51, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: {
        options: [{ label: "Purchase Transaction", value: "Purchase" }, { label: "Refinance Transaction", value: "Refinance" }, { label: "Other (describe)", value: "Other" }]
      }
    },
    { dataType: DATA_TYPE_STRING, source: "FN-36", enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator, },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Lender/Client", source: "FN-37", width: 37, enabled: () => false },
    { dataType: DATA_TYPE_STRING, label: "Address", source: "FN-38", enabled: () => false },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Is the subject property currently offered for sale or has it been offered for sale in the twelve months prior to the effective date of this appraisal?", source: "FN-39|FN-40",
      dataTypeOptions: { options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }] },
      width: 85, hasValidationError: fieldRequiredValidator
    },
    {
      dataType: DATA_TYPE_STRING, label: "Days on market", source: "FN-41", hasValidationError: combineValidator(wholeNumberRequiredOrUnkValidator, fieldRequiredValidator)
    }
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, label: "Report data source(s) used, offering price(s), and date(s).", source: "FN-42" },
  ],
  [
    { label: "Contract", style: { className: DISPLAY_STYLE_HEADER } }
  ],

  [
    {
      dataType: DATA_TYPE_RADIO, label: "I", source: "FN-43|FN-44", hasValidationError: customValidator,
      dataTypeOptions: { options: [{ label: "did", value: "true" }, { label: "did not analyze the contract for sale for the subject purchase transaction. Explain the results of the analysis of the contract for sale or why the analysis was not performed.", value: "false" }] }
    }
  ],

  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, source: "FN-46-1|FN-46-2", hasValidationError: customValidator },
  ],
  [
    { label: "Specify the type of sale associated with the subject property transcation", width: 40 },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FN-45", hasValidationError: customValidator,

      dataTypeOptions: {
        options: [
          { label: "REO Sale", value: "REOSale" },
          { label: "Short Sale", value: "ShortSale" },
          { label: "Court Ordered Sale", value: "CourtOrderedSale" },
          { label: "Estate Sale", value: "EstateSale" },
          { label: "Relocation Sale", value: "RelocationSale" },
          { label: "Non-Arms Length Sale", value: "NonArmsLengthSale" },
          { label: "Arms Length Sale", value: "ArmsLengthSale" },
        ]
      }
    }
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Contract Price $", source: "FN-47", width: 18, hasValidationError: customValidator },
    { dataType: DATA_TYPE_DATE, label: "Date of Contract", source: "FA-48", width: 25, hasValidationError: customValidator },
    {
      dataType: DATA_TYPE_RADIO, label: "Is the property seller the owner of public record?", source: "FN-49|FN-50", width: 35, hasValidationError: customValidator,
      dataTypeOptions: { options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }] }
    },
    { dataType: DATA_TYPE_STRING, label: "Data Source(s)", source: "FN-51", hasValidationError: customValidator },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO,
      label: "Is there any financial assistance (loan charges, sale concessions, gift or downpayment assistance, etc.) to be paid by any party on behalf of the borrower?",
      source: "FN-52|FN-53",
      dataTypeOptions: { options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }] },
      style: { borderBottom: 0 },
      hasValidationError: customValidator
    }
  ],
  [
    {
      dataType: DATA_TYPE_STRING, label: "If Yes, report the total dollar amount and describe the items to be paid. $", source: "FN-54", width: 45, style: { borderBottom: 0 }, enabled: shouldBeEnabled, hasValidationError: customValidator,
    },
    { style: { borderBottom: 0 } }
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, source: "FN-56-1|FN-56-2|FN-56-3", enabled: shouldBeEnabled, hasValidationError: customValidator },
  ],
  [
    { label: "Market", style: { className: DISPLAY_STYLE_HEADER } }
  ],
  [
    { label: "Note: Race and the racial composition of the market are not appraisal factors.", style: { borderBottom: 3, className: DISPLAY_STYLE_BOLD } }
  ],
  [
    { label: "Market Characteristics", style: { className: DISPLAY_STYLE_SHADED, borderRight: 1 }, width: 31.5 },
    { label: "One-Unit Housing Trends", style: { className: DISPLAY_STYLE_SHADED, borderRight: 1 }, width: 38.75 },
    { label: "One-Unit Housing", style: { className: DISPLAY_STYLE_SHADED, borderRight: 1 }, width: 14.5 },
    { label: "Present Land Use %", style: { className: DISPLAY_STYLE_SHADED } },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Location", labelWidth: 19, width: 31.5, source: "FN-57|FN-58|FN-59", hasValidationError: fieldRequiredValidator,
      style: { borderRight: 1 },
      dataTypeOptions: { options: [{ label: "Urban", value: "Urban", width: 26 }, { label: "Suburban", value: "Suburban", width: 26 }, { label: "Rural", value: "Rural" }] }
    },
    {
      dataType: DATA_TYPE_RADIO, label: "Property Values", labelWidth: 26, width: 38.75, source: "FN-66|FN-67|FN-68", hasValidationError: fieldRequiredValidator,
      style: { borderRight: 1 },
      dataTypeOptions: { options: [{ label: "Increasing", value: "Increasing", width: 27 }, { label: "Stable", value: "Stable", width: 22 }, { label: "Declining", value: "Declining" }] }
    },
    { label: "PRICE", width: 7.25, style: { className: DISPLAY_STYLE_CENTER } },
    { label: "AGE", width: 7.25, style: { borderRight: 1, className: DISPLAY_STYLE_CENTER } },
    { dataType: DATA_TYPE_STRING, label: "One-Unit", source: "FN-81", width: 13, hasValidationError: presentLandUseValidator },
    { label: "%" },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Built-Up", source: "FN-60|FN-61|FN-62", labelWidth: 19, width: 31.5, hasValidationError: fieldRequiredValidator,
      style: { borderRight: 1 },
      dataTypeOptions: {
        options: [{ label: "Over 75%", value: "Over75Percent", width: 26 }, { label: "25-75%", value: "25To75Percent", width: 26 }, { label: "Under 25%", value: "Under25Percent" }]
      }
    },
    {
      dataType: DATA_TYPE_RADIO, label: "Demand/Supply", source: "FN-69|FN-70|FN-71", labelWidth: 26, width: 38.75, hasValidationError: fieldRequiredValidator,
      style: { borderRight: 1 },
      dataTypeOptions: { options: [{ label: "Shortage", value: "Shortage", width: 27 }, { label: "In Balance", value: "InBalance", width: 22 }, { label: "Over Supply", value: "OverSupply" }] }
    },
    { label: "$ (000)", width: 7.25, style: { className: DISPLAY_STYLE_CENTER } },
    { label: "(yrs)", width: 7.25, style: { borderRight: 1, className: DISPLAY_STYLE_CENTER } },
    { dataType: DATA_TYPE_STRING, label: "2-4 Unit", source: "FN-82", width: 13, hasValidationError: presentLandUseValidator },
    { label: "%" },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Growth", source: "FN-63|FN-64|FN-65", labelWidth: 19, width: 31.5, hasValidationError: fieldRequiredValidator,
      style: { borderRight: 1 },
      dataTypeOptions: { options: [{ label: "Rapid", value: "Rapid", width: 26 }, { label: "Stable", value: "Stable", width: 26 }, { label: "Slow", value: "Slow" }] }
    },
    {
      dataType: DATA_TYPE_RADIO, label: "Marketing Time", source: "FN-72|FN-73|FN-74", labelWidth: 26, width: 38.75, hasValidationError: fieldRequiredValidator,
      style: { borderRight: 1 },
      dataTypeOptions: {
        options: [{ label: "Under 3 mths", value: "UnderThreeMonths", width: 27 }, { label: "3-6 mths", value: "ThreeToSixMonths", width: 22 }, { label: "Over 6 mths", value: "OverSixMonths" }]
      }
    },
    { dataType: DATA_TYPE_STRING, source: "FN-75", width: 5.25, hasValidationError: fieldRequiredValidator },
    { label: "Low", width: 4, style: { className: DISPLAY_STYLE_CENTER } },
    { dataType: DATA_TYPE_STRING, source: "FN-78", width: 5.25, style: { borderRight: 1 }, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, source: "FN-83", label: "Multi-Family", width: 13, hasValidationError: presentLandUseValidator },
    { label: "%" },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Market Boundaries", source: "FN-86-1|FN-86-2", width: 70.25, style: { borderRight: 1 }, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, source: "FN-76", width: 5.25, hasValidationError: fieldRequiredValidator },
    { label: "High", width: 4, style: { className: DISPLAY_STYLE_CENTER } },
    { dataType: DATA_TYPE_STRING, source: "FN-79", width: 5.25, style: { borderRight: 1 }, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, source: "FN-84", label: "Commercial", width: 13, hasValidationError: presentLandUseValidator },
    { label: "%" },
  ],
  [
    { width: 70.25, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-77", width: 5.25, hasValidationError: fieldRequiredValidator },
    { label: "Pred.", width: 4, style: { className: DISPLAY_STYLE_CENTER } },
    { dataType: DATA_TYPE_STRING, source: "FN-80", width: 5.25, style: { borderRight: 1 }, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "Other", source: "FN-85", width: 13, hasValidationError: presentLandUseValidator },
    { label: "%" },
  ],
  [
    { width: 70.25, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, label: "Present Land Use Other", source: "present-land-use-other", enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator },
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, label: "Market Description", source: "neighborhood-description", hasValidationError: fieldRequiredValidator },
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, label: "Market Conditions (including support for the above conclusions)", source: "FN-88-1|FN-88-2|FN-88-3", hasValidationError: fieldRequiredValidator },
  ],
  [
    { label: "Site", style: { className: DISPLAY_STYLE_HEADER } }
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Dimensions", source: "FN-89", width: 37, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "Area", source: "FN-90", width: 21, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "Shape", source: "FN-91", width: 21, hasValidationError: fieldRequiredValidator },
    { label: "View rating:", width: 8 },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-92-1", hasValidationError: fieldRequiredValidator,
      dataTypeOptions: {
        options: [
          { label: "Neutral", value: "Neutral" },
          { label: "Beneficial", value: "Beneficial" },
          { label: "Adverse", value: "Adverse" },
        ]
      }
    },
  ],
  [
    { label: "View Type 1", width: 8 },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-92-2", width: 10, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: {
        options: [
          { label: "Water View", value: "WaterView" },
          { label: "Pastoral", value: "PastoralView" },
          { label: "Woods View", value: "WoodsView" },
          { label: "Park View", value: "ParkView" },
          { label: "Golf Course", value: "GolfCourseView" },
          { label: "City Skyline", value: "CityViewSkylineView" },
          { label: "Mountain", value: "MountainView" },
          { label: "Residential", value: "ResidentialView" },
          { label: "City Street", value: "CityStreetView" },
          { label: "Industrial", value: "IndustrialView" },
          { label: "Pwr Lines", value: "PowerLines" },
          { label: "Limited Sight", value: "LimitedSight" },
          { label: "Other", value: "Other" }
        ]
      }
    },
    { dataType: DATA_TYPE_STRING, label: "View Type 1 Other", source: "FA-92-3", width: 32, enabled: shouldBeEnabled, hasValidationError: combineValidator(fieldRequiredValidator, stringLengthValidator(19)) },
    { label: "View Type 2", width: 8 },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-92-4", width: 10,
      dataTypeOptions: {
        options: [
          { label: "Water View", value: "WaterView" },
          { label: "Pastoral", value: "PastoralView" },
          { label: "Woods View", value: "WoodsView" },
          { label: "Park View", value: "ParkView" },
          { label: "Golf Course", value: "GolfCourseView" },
          { label: "City Skyline", value: "CityViewSkylineView" },
          { label: "Mountain", value: "MountainView" },
          { label: "Residential", value: "ResidentialView" },
          { label: "City Street", value: "CityStreetView" },
          { label: "Industrial", value: "IndustrialView" },
          { label: "Pwr Lines", value: "PowerLines" },
          { label: "Limited Sight", value: "LimitedSight" },
          { label: "Other", value: "Other" }
        ]
      }
    },
    { dataType: DATA_TYPE_STRING, label: "View Type 2 Other", source: "FA-92-5", width: 32, enabled: shouldBeEnabled, hasValidationError: combineValidator(fieldRequiredValidator, stringLengthValidator(19)) }
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Specific Zoning Classification", source: "FN-95", width: 37, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "Zoning Description", source: "FN-96", hasValidationError: fieldRequiredValidator },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Zoning Compliance", source: "FN-97|FN-98|FN-99|FN-100", width: 62.5, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Legal", value: "Legal" }, { label: "Legal Nonconforming (Grandfathered Use)", value: "Nonconforming" }, { label: "No Zoning", value: "NoZoning" }, { label: "Illegal (describe)", value: "Illegal" }] }
    },
    { dataType: DATA_TYPE_STRING, source: "FN-101", enabled: shouldBeEnabled },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, width: 76.7, label: "Is the highest and best use of the subject property as improved (or as proposed per plans and specifications) the present use?", source: "FN-102|FN-103", hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }] }
    },
    { label: "If No, describe", source: "Highest And Best Use If No Describe Label", enabled: shouldBeEnabled },
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, source: "FN-104-1|FN-104-2", enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator },
  ],
  // Example of dynamic number of repeat elements
  // This defines where the repeat should be situated in the form and how it should be displayed
  // All the common properties between the repeats are defined here like dataType, label and options
  // Source could be anything as it is only used to reference this definition in the Appraisal1004p component
  // All the data dependent properties are added in the Appraisal1004p component
  [
    {
      dataType: DATA_TYPE_DROPDOWN, label: "Electrical service", source: "electrical-service-2",
      dataTypeOptions: {
        options: [{ label: "Solar", value: "Solar" }, { label: "Public", value: "Public" }, { label: "Generator", value: "Generator" },
        { label: "Wind", value: "Wind" }, { label: "Hydro Electric", value: "Hydro Electric" }, { label: "No Electrical Service", value: "No Electrical Service" }]
      }
    },
    { dataType: DATA_TYPE_CHECKBOX, label: "This is an off-grid service", source: "off-grid-service" },
    {
      dataType: DATA_TYPE_DROPDOWN, label: "Solar panel ownership", source: "solar-panel-ownership",
      dataTypeOptions: {
        options: [{ label: "Homeowner owned", value: "Homeowner owned" }, { label: "Lease", value: "Lease" },
        { label: "Power purchase agreement", value: "Power purchase agreement" }, { label: "Financed", value: "Financed" }]
      }
    },
  ],
  [
    { label: "Utilities", width: 12, style: { className: DISPLAY_STYLE_BOLD } },
    { label: "Public", width: 5, style: { className: DISPLAY_STYLE_BOLD } },
    { label: "None", width: 4.5, style: { className: DISPLAY_STYLE_BOLD } },
    { label: "Other (describe)", width: 40.5, style: { className: DISPLAY_STYLE_BOLD } },
    { label: "Public", width: 5, style: { className: DISPLAY_STYLE_BOLD } },
    { label: "None", width: 4.5, style: { className: DISPLAY_STYLE_BOLD } },
    { label: "Other (describe)", style: { className: DISPLAY_STYLE_BOLD } },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Electricity", source: "FN-105|FN-106", labelWidth: 54, width: 25, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ value: "Public", width: 20 }, { value: "None", width: 20 }, { value: "NonPublic" }] }
    },
    { dataType: DATA_TYPE_STRING, source: "FN-107", width: 25, enabled: shouldBeEnabled, hasValidationError: customValidator },
    {
      dataType: DATA_TYPE_RADIO, label: "Water", source: "FN-111|FN-112", labelWidth: 54, width: 25, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ value: "Public", width: 20 }, { value: "None", width: 20 }, { value: "NonPublic" }] }
    },
    { dataType: DATA_TYPE_STRING, source: "FN-113", enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Gas", source: "FN-108|FN-109", labelWidth: 54, width: 25, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ value: "Public", width: 20 }, { value: "None", width: 20 }, { value: "NonPublic" }] }
    },
    { dataType: DATA_TYPE_STRING, source: "FN-110", width: 25, enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator },
    {
      dataType: DATA_TYPE_RADIO, label: "Sanitary Sewer", source: "FN-114|FN-115", labelWidth: 54, width: 25, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ value: "Public", width: 20 }, { value: "None", width: 20 }, { value: "NonPublic" }] }
    },
    { dataType: DATA_TYPE_STRING, source: "FN-116", enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator },
  ],
  [
    { label: "Off-site Improvements—Type (Describe)", width: 80, style: { className: DISPLAY_STYLE_BOLD } },
    { label: "Public", style: { className: DISPLAY_STYLE_BOLD } },
    { label: "Private", style: { className: DISPLAY_STYLE_BOLD } },
    { label: "None", style: { className: DISPLAY_STYLE_BOLD } },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Street", source: "FN-117", width: 80, enabled: shouldBeEnabled, hasValidationError: customValidator },
    {
      dataType: DATA_TYPE_RADIO, source: "FN-118|FN-119", labelWidth: 69, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ value: "Public", width: 37 }, { value: "Private", width: 37 }, { value: "Unknown" }] }
    },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Alley", source: "FN-120", width: 80, enabled: shouldBeEnabled, hasValidationError: customValidator },
    {
      dataType: DATA_TYPE_RADIO, source: "FN-121|FN-122", labelWidth: 69, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ value: "Public", width: 37 }, { value: "Private", width: 37 }, { value: "Unknown" }] }
    },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "FEMA Special Flood Hazard Area", source: "FN-123|FN-124", width: 31, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }] }
    },
    { dataType: DATA_TYPE_STRING, label: "FEMA Flood Zone", source: "FN-125", width: 20 },
    { dataType: DATA_TYPE_STRING, label: "FEMA Map #", source: "FN-126", width: 24.7 },
    { dataType: DATA_TYPE_DATE, label: "FEMA Map Date", source: "FN-127" },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Are the utilities and off-site improvements typical for the market area?", source: "FN-128|FN-129", width: 51.7, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }] }
    },
    { dataType: DATA_TYPE_STRING, label: "If No, describe", source: "FN-130", enabled: shouldBeEnabled },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Are there any adverse site conditions or external factors (easements, encroachments, environmental conditions, land uses, etc.)?", source: "FN-131|FN-132", width: 78, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }] }
    },
    { label: "If Yes, describe", source: "Adverse Conditions If Yes Describe Label" },
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, source: "FN-133-1|FN-133-2|FN-133-3", hasValidationError: customValidator },
  ],
  [
    { label: "Improvements", style: { className: DISPLAY_STYLE_HEADER } }
  ],
  [
    { label: "General Description", width: 25, style: { className: DISPLAY_STYLE_SHADED, borderRight: 2 } },
    { label: "Foundation", width: 25, style: { className: DISPLAY_STYLE_SHADED, borderRight: 2 } },
    { label: "Exterior Description", width: 13.9, style: { className: [DISPLAY_STYLE_SHADED, DISPLAY_STYLE_LEFT] } },
    { label: "materials/condition", width: 13.9, style: { className: [DISPLAY_STYLE_SHADED, DISPLAY_STYLE_RIGHT], borderRight: 2 } },
    { label: "Interior", width: 10, style: { className: [DISPLAY_STYLE_SHADED, DISPLAY_STYLE_LEFT] } },
    { label: "materials/condition", style: { className: [DISPLAY_STYLE_SHADED, DISPLAY_STYLE_RIGHT] } },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Units", source: "FN-134|FN-135", width: 25, style: { borderRight: 2 }, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "One", value: "false" }, { label: "One with Accessory Unit", value: "true", hasValidationError: fieldRequiredValidator }] }
    },

    { dataType: DATA_TYPE_CHECKBOX, label: "Concrete Slab", source: "FN-147", width: 12, hasValidationError: customValidator, validationAdjustments: foundationFilter() },
    { dataType: DATA_TYPE_CHECKBOX, label: "Crawl Space", source: "FN-148", width: 13, style: { borderRight: 2 }, hasValidationError: customValidator, validationAdjustments: foundationFilter() },
    { dataType: DATA_TYPE_STRING, label: "Foundation Walls", source: "FA-158-1", width: 20.5, hasValidationError: fieldRequiredValidator },
    { label: "/", width: 1 },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-158-2", width: 6.0, style: { borderRight: 2 }, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Excellent", value: "Exlnt" }, { label: "Good", value: "Good" }, { label: "Avg", value: "Avg" }, { label: "Fair", value: "Fair" }, { label: "Poor", value: "Poor" }, { label: "N/A", value: "N/A" }] }
    },
    { dataType: DATA_TYPE_STRING, label: "Floors", source: "FA-165-1", width: 15, hasValidationError: fieldRequiredValidator },
    { label: "/", width: 1 },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-165-2", hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Excellent", value: "Exlnt" }, { label: "Good", value: "Good" }, { label: "Avg", value: "Avg" }, { label: "Fair", value: "Fair" }, { label: "Poor", value: "Poor" }, { label: "N/A", value: "N/A" }] }
    },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "# of Stories", source: "FN-136", width: 25, style: { borderRight: 2 }, hasValidationError: combineValidator(numberRequiredValidator, fieldRequiredValidator) },
    { dataType: DATA_TYPE_CHECKBOX, label: "Full Basement", source: "FN-149", width: 12, hasValidationError: customValidator, validationAdjustments: foundationFilter() },
    { dataType: DATA_TYPE_CHECKBOX, label: "Partial Basement", source: "FN-150", width: 13, style: { borderRight: 2 }, hasValidationError: customValidator, validationAdjustments: foundationFilter() },
    { dataType: DATA_TYPE_STRING, label: "Exterior Walls", source: "FA-159-1", width: 20.5, hasValidationError: fieldRequiredValidator },
    { label: "/", width: 1 },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-159-2", width: 6.0, style: { borderRight: 2 }, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Excellent", value: "Exlnt" }, { label: "Good", value: "Good" }, { label: "Avg", value: "Avg" }, { label: "Fair", value: "Fair" }, { label: "Poor", value: "Poor" }, { label: "N/A", value: "N/A" }] }
    },
    { dataType: DATA_TYPE_STRING, label: "Walls", source: "FA-166-1", width: 15, hasValidationError: fieldRequiredValidator },
    { label: "/", width: 1 },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-166-2", hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Excellent", value: "Exlnt" }, { label: "Good", value: "Good" }, { label: "Avg", value: "Avg" }, { label: "Fair", value: "Fair" }, { label: "Poor", value: "Poor" }, { label: "N/A", value: "N/A" }] }
    },
  ],
  [ //// ADU Section
    { //
      dataType: DATA_TYPE_TOOLTIP, label: "ADU GLA should be included in the overall GLA", source: "TOOLTIP-ADU-01A", enabled: shouldBeEnabled, visible: shouldBeVisible, direction: "right", width: 3,
    },
    {
      dataType: DATA_TYPE_TOOLTIP, label: "ADU GLA Should not be included in the overall GLA. ADU must be represented as a separate line item in the comparables grid’", source: "TOOLTIP-ADU-01B", enabled: shouldBeEnabled, visible: shouldBeVisible, direction: "right", width: 3,
    },
    {
      dataType: DATA_TYPE_RADIO, label: "Is there interior access between the ADU and the main living area?", source: "ADU-01", enabled: shouldBeEnabled, visible: shouldBeVisible, hasValidationError: fieldRequiredValidator, width: 25, style: { borderRight: 2 },
      dataTypeOptions: { options: [{ label: "Yes", value: "Yes" }, { label: "No", value: "No" }] },
    },
    {
      dataType: DATA_TYPE_TOOLTIP, label: "If ADU is attached and non-permitted the report should be completed “as is” with a cost to cure provided to return the structure to its original state", source: "TOOLTIP-ADU-03", enabled: shouldBeEnabled, visible: shouldBeVisible, width: 3, direction: "right",
    },
    {
      dataType: DATA_TYPE_RADIO, label: "Is the ADU permitted?", source: "ADU-03", enabled: shouldBeEnabled, visible: shouldBeVisible, width: 25, style: { borderRight: 2 }, hasValidationError: customValidator,
      dataTypeOptions: { options: [{ label: "Yes", value: "Yes" }, { label: "No", value: "No" }] }
    },
    { //
      dataType: DATA_TYPE_RADIO, label: "Is the unit legally conforming?", source: "ADU-05", enabled: shouldBeEnabled, visible: shouldBeVisible, width: 27.8, style: { borderRight: 2 }, hasValidationError: customValidator,
      dataTypeOptions: { options: [{ label: "Yes", value: "Yes" }, { label: "No", value: "No" }] }
    },
    { //
      dataType: DATA_TYPE_RADIO, label: "Is the ADU typical for the area?", source: "ADU-06", enabled: shouldBeEnabled, visible: shouldBeVisible, style: { borderRight: 2 }, hasValidationError: customValidator,
      dataTypeOptions: { options: [{ label: "Yes", value: "Yes" }, { label: "No", value: "No" }] }
    },
  ],
  [ ////
    {
      dataType: DATA_TYPE_RADIO, label: "Is there any affect on marketability?", source: "ADU-07", enabled: shouldBeEnabled, visible: shouldBeVisible, width: 25, style: { borderRight: 2 }, hasValidationError: customValidator,
      dataTypeOptions: { options: [{ label: "Yes", value: "Yes" }, { label: "No", value: "No" }] }
    },
    { dataType: DATA_TYPE_STRING, label: "Please Elaborate:", source: "ADU-07A", enabled: shouldBeEnabled, visible: shouldBeVisible, style: { borderRight: 2 }, hasValidationError: customValidator, },
  ],
  [ ////
    {
      dataType: DATA_TYPE_TOOLTIP, label: "If you can not locate a sale with an ADU it can not be given value in the report", source: "TOOLTIP-ADU-08", enabled: shouldBeEnabled, visible: shouldBeVisible, width: 3, direction: "right",
    },
    {
      dataType: DATA_TYPE_RADIO, label: "Is there a comparable sale with an ADU?", source: "ADU-08", enabled: shouldBeEnabled, visible: shouldBeVisible, width: 25, style: { borderRight: 2 }, hasValidationError: customValidator,
      dataTypeOptions: { options: [{ label: "Yes", value: "Yes" }, { label: "No", value: "No" }] }
    },
    { dataType: DATA_TYPE_STRING, label: "Please Elaborate:", source: "ADU-08A", enabled: shouldBeEnabled, visible: shouldBeVisible, style: { borderRight: 2 }, hasValidationError: customValidator, },
  ],
  [ ////
    { dataType: DATA_TYPE_MULTI_LINE_STRING, label: "ADU Additional Notes:", source: "ADU-10", enabled: shouldBeEnabled, visible: shouldBeVisible, height: 10, style: { borderRight: 2 } },
  ], //// End ADU Section
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Type", source: "FN-137|FN-138|FN-139", width: 25, style: { borderRight: 2 }, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Det.", value: "Detached" }, { label: "Att.", value: "Attached" }, { label: "S-Det./End Unit", value: "SemiDetached" }] }
    },
    { dataType: DATA_TYPE_STRING, label: "Basement Area", width: 20, source: "FN-151", hasValidationError: wholeNumberRequiredValidator },
    { label: "sq. ft.", width: 5, style: { borderRight: 2 } },
    { dataType: DATA_TYPE_STRING, label: "Roof Surface", source: "FA-160-1", width: 20.5, hasValidationError: fieldRequiredValidator },
    { label: "/", width: 1, },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-160-2", width: 6.0, style: { borderRight: 2 }, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Excellent", value: "Exlnt" }, { label: "Good", value: "Good" }, { label: "Avg", value: "Avg" }, { label: "Fair", value: "Fair" }, { label: "Poor", value: "Poor" }, { label: "N/A", value: "N/A" }] }
    },
    { dataType: DATA_TYPE_STRING, label: "Trim/Finish", source: "FA-167-1", width: 15, hasValidationError: fieldRequiredValidator, },
    { label: "/", width: 1 },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-167-2", hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Excellent", value: "Exlnt" }, { label: "Good", value: "Good" }, { label: "Avg", value: "Avg" }, { label: "Fair", value: "Fair" }, { label: "Poor", value: "Poor" }, { label: "None", value: "None" }, { label: "N/A", value: "N/A" }] }
    },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, source: "FN-140|FN-141|FN-142", width: 25, style: { borderRight: 2 }, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Existing", value: "Existing" }, { label: "Proposed", value: "Proposed" }, { label: "Under Const.", value: "UnderConstruction" }] }
    },
    { dataType: DATA_TYPE_STRING, label: "Basement Finish", source: "FN-152", width: 22.8, hasValidationError: combineValidator(wholeNumberRequiredValidator, percentageRequiredValidator) },
    { label: "%", width: 2.2, style: { borderRight: 2 } },
    { dataType: DATA_TYPE_STRING, label: "Gutters & Downspouts", source: "FA-161-1", width: 20.5, hasValidationError: fieldRequiredValidator },
    { label: "/", width: 1 },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-161-2", width: 6.0, style: { borderRight: 2 }, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Excellent", value: "Exlnt" }, { label: "Good", value: "Good" }, { label: "Avg", value: "Avg" }, { label: "Fair", value: "Fair" }, { label: "Poor", value: "Poor" }, { label: "N/A", value: "N/A" }] }
    },
    { dataType: DATA_TYPE_STRING, label: "Bath Floor", source: "FA-168-1", width: 15, hasValidationError: fieldRequiredValidator },
    { label: "/", width: 1 },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-168-2", hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Excellent", value: "Exlnt" }, { label: "Good", value: "Good" }, { label: "Avg", value: "Avg" }, { label: "Fair", value: "Fair" }, { label: "Poor", value: "Poor" }, { label: "N/A", value: "N/A" }] }
    },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Design (Style)", source: "FN-143", width: 25, style: { borderRight: 2 }, hasValidationError: fieldRequiredValidator, },
    { dataType: DATA_TYPE_CHECKBOX, label: "Outside Entry/Exit", source: "FA-153", width: 14 },
    { dataType: DATA_TYPE_CHECKBOX, label: "Sump Pump", source: "FN-154", width: 11, style: { borderRight: 2 } },
    { dataType: DATA_TYPE_STRING, label: "Window Type", source: "FA-162-1", width: 20.5, hasValidationError: fieldRequiredValidator },
    { label: "/", width: 1 },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-162-2", width: 6.0, style: { borderRight: 2 }, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Excellent", value: "Exlnt" }, { label: "Good", value: "Good" }, { label: "Avg", value: "Avg" }, { label: "Fair", value: "Fair" }, { label: "Poor", value: "Poor" }, { label: "N/A", value: "N/A" }] }
    },
    { dataType: DATA_TYPE_STRING, label: "Bath Wainscot", source: "FA-169-1", width: 15, style: { borderBottom: 3 }, hasValidationError: fieldRequiredValidator },
    { label: "/", width: 1, style: { borderBottom: 3 } },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-169-2", style: { borderBottom: 3 }, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Excellent", value: "Exlnt" }, { label: "Good", value: "Good" }, { label: "Avg", value: "Avg" }, { label: "Fair", value: "Fair" }, { label: "Poor", value: "Poor" }, { label: "None", value: "None" }, { label: "N/A", value: "N/A" }] }
    },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Year Built", source: "FN-145", width: 12, hasValidationError: combineValidator(wholeNumberRequiredOrUnkValidator, fieldRequiredValidator) },
    {
      dataType: DATA_TYPE_DROPDOWN, label: "Estimated", source: "FN-144", width: 13.01, hasValidationError: fieldRequiredValidator, style: { borderRight: 2 },
      dataTypeOptions: { options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }] }
    },
    { label: "Evidence of", width: 12 },
    { dataType: DATA_TYPE_CHECKBOX, label: "Infestation", source: "FN-155", width: 13, style: { borderRight: 2 } },
    { dataType: DATA_TYPE_STRING, label: "Storm Sash/Insulated", source: "FA-163-1", width: 20.5, hasValidationError: fieldRequiredValidator },
    { label: "/", width: 1 },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-163-2", width: 6.0, style: { borderRight: 3 }, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Excellent", value: "Exlnt" }, { label: "Good", value: "Good" }, { label: "Avg", value: "Avg" }, { label: "Fair", value: "Fair" }, { label: "Poor", value: "Poor" }, { label: "None", value: "None" }, { label: "N/A", value: "N/A" }] }
    },
    { label: "Car Storage", width: 9.3 },
    { dataType: DATA_TYPE_CHECKBOX, label: "None", source: "FN-201", hasValidationError: customValidator, validationAdjustments: carStorageFilter() },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Effective Age (Yrs)", source: "FN-146", width: 25, style: { borderRight: 2, borderBottom: 3 }, hasValidationError: combineValidator(wholeNumberRequiredOrUnkValidator, fieldRequiredValidator) },
    { dataType: DATA_TYPE_CHECKBOX, label: "Dampness", source: "FN-156", width: 12, style: { borderBottom: 3 } },
    { dataType: DATA_TYPE_CHECKBOX, label: "Settlement", source: "FN-157", width: 13, style: { borderRight: 2, borderBottom: 3 } },

    { label: "Screens", width: 15, style: { borderBottom: 3 } },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-164-1", width: 5.5, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Yes", value: "Yes" }, { label: "No", value: "None" }] },
      style: { borderBottom: 3 }
    },
    { label: "/", width: 1, style: { borderBottom: 3 } },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-164-2", width: 6.0, style: { borderRight: 3, borderBottom: 3 }, hasValidationError: customValidator,
      dataTypeOptions: { options: [{ label: "Excellent", value: "Exlnt" }, { label: "Good", value: "Good" }, { label: "Avg", value: "Avg" }, { label: "Fair", value: "Fair" }, { label: "Poor", value: "Poor" }, { label: "None", value: "None" }, { label: "N/A", value: "N/A" }] }
    },
    { dataType: DATA_TYPE_CHECKBOX, label: "Driveway", source: "FN-202", width: 9.3, hasValidationError: customValidator, validationAdjustments: carStorageFilter() },
    { dataType: DATA_TYPE_STRING, label: "# of Cars", source: "FN-203", hasValidationError: customValidator },
  ],
  [
    { label: "Attic", width: 13 },
    { dataType: DATA_TYPE_CHECKBOX, label: "None", source: "FN-170", width: 12.01, style: { borderRight: 2 }, dataTypeOptions: { checkedValue: "true", uncheckedValue: "false" }, hasValidationError: customValidator, validationAdjustments: atticFilter() }, //12.01 width because i was having a pixel rounding issue :(
    { label: "Heating", width: 5.2 },
    { dataType: DATA_TYPE_CHECKBOX, label: "FWA", source: "FN-177", width: 5.5, style: { borderRight: 1 }, hasValidationError: customValidator, validationAdjustments: heatingFilter() },
    { dataType: DATA_TYPE_CHECKBOX, label: "HWBB", source: "FN-178", width: 6.7, style: { borderRight: 1 }, hasValidationError: customValidator, validationAdjustments: heatingFilter() },
    { dataType: DATA_TYPE_CHECKBOX, label: "Radiant", source: "FN-179", width: 7.6, style: { borderRight: 2 }, hasValidationError: customValidator, validationAdjustments: heatingFilter() },
    { label: "Amenities", width: 13.3 },
    { dataType: DATA_TYPE_CHECKBOX, label: "Woodstove(s)", source: "FN-193", width: 10 },
    { dataType: DATA_TYPE_STRING, label: "#", source: "FN-194", width: 4.5, style: { borderRight: 2 }, enabled: shouldBeEnabled, hasValidationError: customValidator },
    { dataType: DATA_TYPE_STRING, label: "Driveway Surface", source: "FN-204", enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator },
  ],
  [
    { dataType: DATA_TYPE_CHECKBOX, label: "Drop Stair", source: "FN-171", width: 13, hasValidationError: customValidator, validationAdjustments: atticFilter() },
    { dataType: DATA_TYPE_CHECKBOX, label: "Stairs", source: "FN-172", width: 12.01, style: { borderRight: 2 }, hasValidationError: customValidator, validationAdjustments: atticFilter() }, //12.01 width because i was having a pixel rounding issue :(
    { dataType: DATA_TYPE_CHECKBOX, label: "Other", source: "FN-180", width: 6.1, hasValidationError: customValidator, validationAdjustments: heatingFilter() },
    { dataType: DATA_TYPE_STRING, source: "FN-181", width: 6.4, style: { borderRight: 1 }, enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "Fuel", source: "FN-182", width: 12.5, style: { borderRight: 2 }, hasValidationError: customValidator },
    { dataType: DATA_TYPE_CHECKBOX, label: "Fireplace(s)", source: "FN-187", width: 9.3 },
    { dataType: DATA_TYPE_STRING, label: "#", source: "FN-188", width: 4, enabled: shouldBeEnabled, hasValidationError: customValidator },
    { dataType: DATA_TYPE_CHECKBOX, label: "Fence", source: "FN-195", width: 6.3 },
    { dataType: DATA_TYPE_STRING, source: "FN-196", width: 8.2, style: { borderRight: 2 }, enabled: shouldBeEnabled, hasValidationError: customValidator },
    { dataType: DATA_TYPE_CHECKBOX, label: "Att. Garage", source: "FA-209-1", width: 9.3, hasValidationError: customValidator, validationAdjustments: carStorageFilter() },
    { dataType: DATA_TYPE_STRING, label: "# of Cars", source: "FA-209-2", hasValidationError: customValidator },
  ],
  [
    { dataType: DATA_TYPE_CHECKBOX, label: "Floor", source: "FN-173", width: 13, hasValidationError: customValidator, validationAdjustments: atticFilter() },
    { dataType: DATA_TYPE_CHECKBOX, label: "Scuttle", source: "FN-174", width: 12.01, style: { borderRight: 2 }, hasValidationError: customValidator, validationAdjustments: atticFilter() }, //12.01 width because i was having a pixel rounding issue :(
    { label: "Cooling", width: 6.1 },
    { dataType: DATA_TYPE_SPLIT_RADIO, label: "Central Air Conditioning", value: "Central Air Conditioning", source: "FN-183|FN-184|FN-185", width: 18.9, style: { borderRight: 2 }, hasValidationError: customValidator },
    { dataType: DATA_TYPE_CHECKBOX, label: "Patio/Deck", source: "FN-189", width: 8.9 },
    { dataType: DATA_TYPE_STRING, source: "FN-190", width: 4.4, enabled: shouldBeEnabled, hasValidationError: customValidator },
    { dataType: DATA_TYPE_CHECKBOX, label: "Porch", source: "FN-197", width: 6.3 },
    { dataType: DATA_TYPE_STRING, source: "FN-198", width: 8.2, style: { borderRight: 2 }, enabled: shouldBeEnabled, hasValidationError: customValidator },
    { dataType: DATA_TYPE_CHECKBOX, label: "Det. Garage", source: "FA-210-1", width: 9.3, hasValidationError: customValidator, validationAdjustments: carStorageFilter() },
    { dataType: DATA_TYPE_STRING, label: "# of Cars", source: "FA-210-2", hasValidationError: customValidator },
  ],
  [
    { dataType: DATA_TYPE_CHECKBOX, label: "Finished", source: "FN-175", width: 13, style: { borderBottom: 3 }, hasValidationError: customValidator, validationAdjustments: atticFilter() },
    { dataType: DATA_TYPE_CHECKBOX, label: "Heated", source: "FN-176", width: 12.01, style: { borderRight: 2, borderBottom: 3 }, hasValidationError: customValidator, validationAdjustments: atticFilter() }, //12.01 width because i was having a pixel rounding issue :(
    { dataType: DATA_TYPE_SPLIT_RADIO, label: "Individual", value: "Individual", source: "FN-183|FN-184|FN-185", width: 12.5, style: { borderRight: 1, borderBottom: 3 }, hasValidationError: customValidator },
    { dataType: DATA_TYPE_SPLIT_RADIO, label: "Other", value: "Other", source: "FN-183|FN-184|FN-185", width: 5.9, style: { borderBottom: 3 }, hasValidationError: customValidator },
    { dataType: DATA_TYPE_STRING, source: "FN-186", width: 6.6, style: { borderRight: 2, borderBottom: 3 }, enabled: shouldBeEnabled, hasValidationError: customValidator },
    { dataType: DATA_TYPE_CHECKBOX, label: "Pool", source: "FN-191", width: 5.2, style: { borderBottom: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-192", width: 8.1, style: { borderBottom: 1 }, enabled: shouldBeEnabled, hasValidationError: customValidator },
    { dataType: DATA_TYPE_CHECKBOX, label: "Other", source: "FN-199", width: 6.3, style: { borderBottom: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-200", width: 8.2, style: { borderRight: 2, borderBottom: 1 }, enabled: shouldBeEnabled, hasValidationError: customValidator },
    { dataType: DATA_TYPE_CHECKBOX, label: "Bltn Garage", source: "FA-211-1", width: 9.3, hasValidationError: customValidator, validationAdjustments: carStorageFilter() },
    { dataType: DATA_TYPE_STRING, label: "# of Cars", source: "FA-211-2", hasValidationError: customValidator },
  ],
  [
    { width: 77.83, style: { borderRight: 3 } },
    { dataType: DATA_TYPE_CHECKBOX, label: "Carport", source: "FN-207", width: 9.3, hasValidationError: customValidator, validationAdjustments: carStorageFilter() },
    { dataType: DATA_TYPE_STRING, label: "# of Cars", source: "FN-208", hasValidationError: customValidator },
  ],
  [
    { width: 77.83, style: { borderRight: 3 } },
    { dataType: DATA_TYPE_CHECKBOX, label: "Att.", source: "FA-209", width: 7.4, enabled: shouldBeEnabled, style: { borderBottom: 3 }, dataTypeOptions: { checkedValue: "Attached", uncheckedValue: null }, hasValidationError: customValidator },
    { dataType: DATA_TYPE_CHECKBOX, label: "Det.", source: "FA-210", width: 7.4, enabled: shouldBeEnabled, style: { borderBottom: 3 }, dataTypeOptions: { checkedValue: "Detached", uncheckedValue: null }, hasValidationError: customValidator },
    { dataType: DATA_TYPE_CHECKBOX, label: "Built-in", source: "FA-211", enabled: shouldBeEnabled, style: { borderBottom: 3 }, dataTypeOptions: { checkedValue: "BuiltIn", uncheckedValue: null }, hasValidationError: customValidator },
  ],
  [
    { label: "Appliances", width: 6.9, style: { borderBottom: 3 } },
    { dataType: DATA_TYPE_CHECKBOX, label: "Refrigerator", source: "FN-212", width: 9.5, style: { borderBottom: 3 } },
    { dataType: DATA_TYPE_CHECKBOX, label: "Range/Oven", source: "FN-213", width: 9.9, style: { borderBottom: 3 } },
    { dataType: DATA_TYPE_CHECKBOX, label: "Dishwasher", source: "FN-214", width: 9, style: { borderBottom: 3 } },
    { dataType: DATA_TYPE_CHECKBOX, label: "Disposal", source: "FN-215", width: 7.6, style: { borderBottom: 3 } },
    { dataType: DATA_TYPE_CHECKBOX, label: "Microwave", source: "FN-216", width: 8.5, style: { borderBottom: 3 } },
    { dataType: DATA_TYPE_CHECKBOX, label: "Washer/Dryer", source: "FN-217", width: 10.1, style: { borderBottom: 3 } },
    { dataType: DATA_TYPE_CHECKBOX, label: "Other (describe)", source: "FN-218", width: 11.8, style: { borderBottom: 3 } },
    { dataType: DATA_TYPE_STRING, source: "FN-219", style: { borderBottom: 3 } },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Finished area above grade contains:", source: "FN-220", width: 30, style: { className: DISPLAY_STYLE_RIGHT_ALIGN_STRING }, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "Rooms", source: "FN-221", width: 12.8, style: { className: DISPLAY_STYLE_RIGHT_ALIGN_STRING }, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "Bedrooms", source: "FA-222", width: 12.8, style: { className: DISPLAY_STYLE_RIGHT_ALIGN_STRING }, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "Bath(s)", source: "FN-223", width: 12.8, style: { className: DISPLAY_STYLE_RIGHT_ALIGN_STRING }, hasValidationError: fieldRequiredValidator },
    { label: "Square Feet of Gross Living Area Above Grade" }
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, label: "Additional Features (special energy efficient items, etc.)", source: "FN-224-1|FN-224-2" },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Overall Condition Type", source: "FN-225", hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "C1", value: "C1" }, { label: "C2", value: "C2" }, { label: "C3", value: "C3" }, { label: "C4", value: "C4" }, { label: "C5", value: "C5" }, { label: "C6", value: "C6" }] }
    }
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Has any material work been done in the kitchen or bathrooms of the residence within the last 15 years?", source: "FN-226", hasValidationError: customValidator,
      dataTypeOptions: { options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }] },
    },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Kitchen", source: "FN-228", hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Not updated", value: "NotUpdated" }, { label: "Updated", value: "Updated" }, { label: "Remodeled", value: "Remodeled" }] },
      width: 35, enabled: shouldBeEnabled
    },
    {
      dataType: DATA_TYPE_RADIO, label: "Performed within last:", source: "FN-229", hasValidationError: customValidator,
      dataTypeOptions: { options: [{ label: "1 yr", value: "LessThanOneYearAgo" }, { label: "1-5 yrs", value: "OneToFiveYearsAgo" }, { label: "6-10 yrs", value: "SixToTenYearsAgo" }, { label: "11-15 yrs", value: "ElevenToFifteenYearsAgo" }, { label: "Timeframe unknown", value: "Unknown" }] },
      enabled: shouldBeEnabled
    },

  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Bathroom", source: "FN-228-1", hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Not updated", value: "NotUpdated" }, { label: "Updated", value: "Updated" }, { label: "Remodeled", value: "Remodeled" }] },
      width: 35, enabled: shouldBeEnabled
    },
    {
      dataType: DATA_TYPE_RADIO, label: "Performed within last:", source: "FN-229-1", hasValidationError: customValidator,
      dataTypeOptions: { options: [{ label: "1 yr", value: "LessThanOneYearAgo" }, { label: "1-5 yrs", value: "OneToFiveYearsAgo" }, { label: "6-10 yrs", value: "SixToTenYearsAgo" }, { label: "11-15 yrs", value: "ElevenToFifteenYearsAgo" }, { label: "Timeframe unknown", value: "Unknown" }] },
      enabled: shouldBeEnabled
    },

  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, label: "Describe the condition of the property (including needed repairs, deterioration, renovations, remodeling, etc.).", source: "FA-230" },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Are there any physical deficiencies or adverse conditions that affect the livability, soundness, or structural integrity of the property?",
      source: "FN-231|FN-232", width: 77.5,
      hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }] }
    },
    { label: "If Yes, describe", source: "Physical Deficiencies If Yes Describe Label" },
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, source: "FN-233-1|FN-233-2|FN-233-3", hasValidationError: customValidator },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Does the property generally conform to the neighborhood (functional utility, style, condition, use, construction, etc.)?",
      source: "FN-234|FN-235", width: 70,
      hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }] }
    },
    { label: "If No, describe", source: "General Conformity If No Describe Label" },
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, source: "FN-236-1|FN-236-2|FN-236-3", hasValidationError: customValidator },
  ],
  [
    { label: "Sales Comparison Approach", style: { className: DISPLAY_STYLE_HEADER } }
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "There are", source: "FN-241", width: 10.5, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "comparable properties currently offered for sale in the subject neighborhood ranging in price from $", source: "FN-242", width: 70.5, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "to $", source: "FN-243", hasValidationError: fieldRequiredValidator },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "There are", source: "FN-244", width: 10.5, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "comparable sales in the subject neighborhood within the past twelve months ranging in sale price from $", source: "FN-245", width: 73, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "to $", source: "FN-246", hasValidationError: fieldRequiredValidator },
  ],
  [
    { label: "Navigate to Comparables with Comparables Search Form to complete the Grid", style: { className: [DISPLAY_STYLE_SHADED, "comp-grid-placeholder"] } }
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "I", source: "FN-367|FN-368", hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "did", value: "true" }, { label: "did not research the sale or transfer history of the subject property and comparable sales. If not, explain", value: "false" }] }
    },
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, source: "FN-369-1|FN-369-2|FN-369-3", enabled: shouldBeEnabled },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "My research", source: "FN-370|FN-371", hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "did", value: "true" }, { label: "did not reveal any prior sales or transfers of the subject property for the three years prior to the effective date of this appraisal.", value: "false" }] }
    },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Data Source(s)", source: "FN-372", hasValidationError: fieldRequiredValidator },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "My research", source: "FN-373|FN-374", hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "did", value: "true" }, { label: "did not reveal any prior sales or transfers of the comparable sales for the year prior to the date of sale of the comparable sale.", value: "false" }] }
    },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Data Source(s)", source: "FN-375", hasValidationError: fieldRequiredValidator },
  ],
  [
    { label: "Report the results of the research and analysis of the prior sale or transfer history of the subject property and comparable sales (report additional prior sales on page 3)." },
  ],
  [
    { label: "ITEM", width: 19.4, style: { borderRight: 1 } },
    { label: "SUBJECT", width: 20, style: { borderRight: 1 } },
    { label: "COMPARABLE SALE # 1", width: 20, enabled: comparableTitleEnabled(1), style: { borderRight: 1 } },
    { label: "COMPARABLE SALE # 2", width: 20, enabled: comparableTitleEnabled(2), style: { borderRight: 1 } },
    { label: "COMPARABLE SALE # 3", enabled: comparableTitleEnabled(3) },
  ],
  [
    { label: "Date of Prior Sale/Transfer", width: 19.4, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-376", width: 20, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-380-1", width: 20, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-380-2", width: 20, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-380-3", enabled: comparableEnabled },
  ],
  [
    { label: "Price of Prior Sale/Transfer", width: 19.4, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-377", width: 20, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-381-1", width: 20, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-381-2", width: 20, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-381-3", enabled: comparableEnabled },
  ],
  [
    { label: "Data Source(s)", width: 19.4, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-378", width: 20, hasValidationError: fieldRequiredValidator, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-382-1", width: 20, hasValidationError: fieldRequiredValidator, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-382-2", width: 20, hasValidationError: fieldRequiredValidator, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-382-3", hasValidationError: fieldRequiredValidator, enabled: comparableEnabled },
  ],
  [
    { label: "Effective Date of Data Source(s)", width: 19.4, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-379", width: 20, hasValidationError: dateRequiredValidator, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-383-1", width: 20, hasValidationError: dateRequiredValidator, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-383-2", width: 20, hasValidationError: dateRequiredValidator, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-383-3", hasValidationError: dateRequiredValidator, enabled: comparableEnabled },
  ],
  [
    { label: "ITEM", width: 39.4, style: { borderRight: 1 } },
    { label: "COMPARABLE SALE # 4", width: 20, enabled: comparableTitleEnabled(4), style: { borderRight: 1 } },
    { label: "COMPARABLE SALE # 5", width: 20, enabled: comparableTitleEnabled(5), style: { borderRight: 1 } },
    { label: "COMPARABLE SALE # 6", enabled: comparableTitleEnabled(6) },
  ],
  [
    { label: "Date of Prior Sale/Transfer", width: 39.4, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-380-4", width: 20, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-380-5", width: 20, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-380-6", enabled: comparableEnabled },
  ],
  [
    { label: "Price of Prior Sale/Transfer", width: 39.4, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-381-4", width: 20, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-381-5", width: 20, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-381-6", enabled: comparableEnabled },
  ],
  [
    { label: "Data Source(s)", width: 39.4, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-382-4", width: 20, hasValidationError: fieldRequiredValidator, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-382-5", width: 20, hasValidationError: fieldRequiredValidator, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-382-6", hasValidationError: fieldRequiredValidator, enabled: comparableEnabled },
  ],
  [
    { label: "Effective Date of Data Source(s)", width: 39.4, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-383-4", width: 20, hasValidationError: dateRequiredValidator, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-383-5", width: 20, hasValidationError: dateRequiredValidator, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-383-6", hasValidationError: dateRequiredValidator, enabled: comparableEnabled },
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, label: "Analysis of prior sale or transfer history of the subject property and comparable sales", source: "FN-384-1|FN-384-2|FN-384-3|FN-384-4|FN-384-5|FN-384-6", hasValidationError: fieldRequiredValidator },
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, label: "Summary of Sales Comparison Approach", source: "FN-385-1|FN-385-2|FN-385-3|FN-385-4|FN-385-5|FN-385-6|FN-385-7|FN-385-8", hasValidationError: fieldRequiredValidator },
  ],
  [
    { dataType: DATA_TYPE_STRING, source: "FEE_PAID_APPRAISER", enabled: () => false },
    { dataType: DATA_TYPE_STRING, source: "AMC_REGISTRATION", enabled: () => false },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Indicated Value by Sales Comparison Approach $", source: "FN-386" },
  ],
  [
    { label: "Reconciliation", style: { className: DISPLAY_STYLE_HEADER } },
  ],
  [
    { label: "Indicated Value by:", width: 13, style: { className: DISPLAY_STYLE_BOLD } },
    { dataType: DATA_TYPE_STRING, label: "Sales Comparison Approach $", source: "FN-387", width: 28.6, style: { className: DISPLAY_STYLE_BOLD } },
    { dataType: DATA_TYPE_STRING, label: "Cost Approach (if developed) $", source: "FN-388", width: 28.2, style: { className: DISPLAY_STYLE_BOLD } },
    { dataType: DATA_TYPE_STRING, label: "Income Approach (if developed) $", source: "FN-389", style: { className: DISPLAY_STYLE_BOLD } },
  ],
  [
    { label: "Final Reconciliation:", width: 15, style: { className: DISPLAY_STYLE_LEFT } },
    { dataType: DATA_TYPE_MULTI_LINE_STRING, source: "FN-390-1|FN-390-2|FN-390-3" },
  ],
  [
    { label: "Exposure Time: A reasonable exposure time for this property is", width: 41.5, style: { className: DISPLAY_STYLE_BOLD } },
    { dataType: DATA_TYPE_STRING, label: "Exposure days range START:", source: "FA-exposure-start", width: 28.5, hasValidationError: combineValidator(wholeNumberRequiredValidator, fieldRequiredValidator) },
    { dataType: DATA_TYPE_STRING, label: "Exposure days range END:", source: "FA-exposure-end", hasValidationError: combineValidator(wholeNumberRequiredValidator, fieldRequiredValidator) }
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "This appraisal is made", source: "FN-391|FN-392|FN-393|FN-394", hasValidationError: fieldRequiredValidator,
      dataTypeOptions: {
        options: [
          { label: "\"as is\",", value: "AsIs" },
          { label: "subject to completion per plans and specifications on the basis of a hypothetical condition that the improvements have been completed,", value: "SubjectToCompletion" },
          { label: "subject to the following repairs or alterations on the basis of a hypothetical condition that the repairs or alterations have been completed, or", value: "SubjectToRepairs" },
          { label: "subject to the following required inspection based on the extraordinary assumption that the condition or deficiency does not require alteration or repair:", value: "SubjectToInspections" },
        ]
      },
      style: { className: DISPLAY_STYLE_MULTI_CHECKBOX_NEW_LINES }
    },
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, source: "FN-395-1|FN-395-2" },
  ],
  [
    {
      label: "Based on a complete visual inspection of the interior and exterior areas of the subject property, defined scope of work, statement of assumptions and limiting conditions, and appraiser’s certification, my (our) opinion of the market value, as defined, of the real property that is the subject of this report is",
      style: { borderBottom: 0, className: DISPLAY_STYLE_BOLD }
    },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "$", source: "FN-396", width: 9, hasValidationError: fieldRequiredValidator, style: { className: DISPLAY_STYLE_BOLD } },
    { dataType: DATA_TYPE_DATE, label: ", as of", source: "FA-397", width: 17, hasValidationError: combineValidator(reportDateValidator, dateRequiredValidator), style: { className: DISPLAY_STYLE_BOLD } },
    { label: ", which is the date of inspection and the effective date of this appraisal.", style: { className: DISPLAY_STYLE_BOLD } },
  ],
  [
    { label: "Appraisal Assignment Type", source: "appraisalAssignmentType", dataType: DATA_TYPE_STRING, enabled: () => false },
  ],
  [
    { label: "Subject Property Data Collection Method", source: "subjectPropertyDataCollection-method", dataType: DATA_TYPE_STRING, enabled: () => false },
  ],
  [
    { label: "Subject Property Data Collection Workforce", source: "subjectPropertyDataCollection-workforce", dataType: DATA_TYPE_STRING, enabled: () => false },
  ],
  [
    { label: "Subject Property Data Collection Date", source: "subjectPropertyDataCollection-dataCollectionDate", dataType: DATA_TYPE_STRING, enabled: () => false },
  ],
  [
    { label: "Inspector", source: "urar_fieldRepName", dataType: DATA_TYPE_STRING, enabled: () => false },
  ],
  [
    { label: "Additional Comments", style: { className: DISPLAY_STYLE_HEADER } },
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, dataTypeOptions: { defaultLines: 10 }, source: "FN-402-1|FN-402-2|FN-402-3|FN-402-4|FN-402-5|FN-402-6|FN-402-7|FN-402-8|FN-402-9|FN-402-10|FN-402-11|FN-402-12|FN-402-13|FN-402-14|FN-402-15|FN-402-16|FN-402-17|FN-402-18|FN-402-19|FN-402-20|FN-402-21|FN-402-22|FN-402-23|FN-402-24|FN-402-25|FN-402-26|FN-402-27|FN-402-28|FN-402-29|FN-402-30|FN-402-31|FN-402-32|FN-402-33|FN-402-34|FN-402-35|FN-402-36|FN-402-37|FN-402-38" },
  ],
  [
    { label: "Cost Approach", style: { className: DISPLAY_STYLE_HEADER } },
  ],
  [
    { label: "COST APPROACH TO VALUE (not required by Fannie Mae)", style: { className: DISPLAY_STYLE_SHADED } },
  ],
  [
    { dataType: DATA_TYPE_CHECKBOX, label: "Cost Approach Required", source: "cost-approach-required", enabled: shouldBeEnabled, dataTypeOptions: { checkedValue: "1", uncheckedValue: "0" } },
  ],
  [
    { label: "Provide adequate information for the lender/client to replicate the below cost figures and calculations.", enabled: costApproachEnabled },
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, label: "Support for the opinion of site value (summary of comparable land sales or other methods for estimating site value)", source: "FN-403-1|FN-403-2|FN-403-3|FN-403-4", enabled: costApproachEnabled, hasValidationError: fieldRequiredValidator },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "ESTIMATED", source: "FN-404|FN-405", width: 50.3, style: { borderRight: 1 }, enabled: costApproachEnabled, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "REPRODUCTION OR", value: "Reproduction" }, { label: "REPLACEMENT COST NEW", value: "Replacement" }] }
    },
    { label: "OPINION OF SITE VALUE", width: 40.2, enabled: costApproachEnabled },
    { dataType: DATA_TYPE_STRING, label: "= $", source: "FN-411", enabled: costApproachEnabled, hasValidationError: fieldRequiredValidator },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Source of cost data", source: "FN-406", width: 50.3, style: { borderRight: 1 }, enabled: costApproachEnabled, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "Dwelling", source: "FN-412", width: 16.2, enabled: costApproachEnabled, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "Sq. Ft. @ $", source: "FN-413", width: 24, enabled: costApproachEnabled, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "= $", source: "FN-414", enabled: costApproachEnabled, hasValidationError: fieldRequiredValidator },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Quality rating from cost service", source: "FN-407", width: 22.8, enabled: costApproachEnabled, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_DATE, label: "Effective date of cost data", source: "FN-408", width: 27.5, style: { borderRight: 1 }, enabled: costApproachEnabled, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, source: "FN-415", width: 8.1, enabled: costApproachEnabled },
    { dataType: DATA_TYPE_STRING, source: "FN-416", width: 8.1, enabled: costApproachEnabled },
    { dataType: DATA_TYPE_STRING, label: "Sq. Ft. @ $", source: "FN-417", width: 24, enabled: costApproachEnabled },
    { dataType: DATA_TYPE_STRING, label: "= $", source: "FN-418", enabled: costApproachEnabled },
  ],
  [
    { width: 50.3, style: { borderRight: 1 }, enabled: costApproachEnabled },
    { dataType: DATA_TYPE_STRING, source: "FN-419", width: 40.2, enabled: costApproachEnabled },
    { dataType: DATA_TYPE_STRING, label: "= $", source: "FN-420", enabled: costApproachEnabled },
  ],
  [
    { width: 50.3, style: { borderRight: 1 }, enabled: costApproachEnabled },
    { dataType: DATA_TYPE_STRING, label: "Garage/Carport", source: "FN-421", width: 16.2, enabled: costApproachEnabled },
    { dataType: DATA_TYPE_STRING, label: "Sq. Ft. @ $", source: "FN-422", width: 24, enabled: costApproachEnabled },
    { dataType: DATA_TYPE_STRING, label: "= $", source: "FN-423", enabled: costApproachEnabled },
  ],
  [
    { width: 50.3, style: { borderRight: 1 }, enabled: costApproachEnabled },
    { label: "Total Estimate of Cost-New", width: 40.2, enabled: costApproachEnabled },
    { dataType: DATA_TYPE_STRING, label: "= $", source: "FN-424", enabled: costApproachEnabled, hasValidationError: fieldRequiredValidator },
  ],
  [
    { width: 50.3, style: { borderRight: 1 }, enabled: costApproachEnabled },
    { label: "Less", width: 9.3, enabled: costApproachEnabled },
    { label: "Physical", width: 6.5, style: { borderRight: 1 }, enabled: costApproachEnabled },
    { label: "Functional", width: 8.2, style: { borderRight: 1 }, enabled: costApproachEnabled },
    { label: "External", enabled: costApproachEnabled },
  ],
  [
    { width: 50.3, style: { borderRight: 1 }, enabled: costApproachEnabled },
    { dataType: DATA_TYPE_STRING, label: "Depreciation", source: "FN-425", width: 15.8, style: { borderRight: 1 }, enabled: costApproachEnabled, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, width: 8.2, source: "FN-426", style: { borderRight: 1 }, enabled: costApproachEnabled, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, width: 16.2, source: "FN-427", enabled: costApproachEnabled, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "= $", source: "FN-428", enabled: costApproachEnabled, hasValidationError: fieldRequiredValidator },
  ],
  [
    { width: 50.3, style: { borderRight: 1 }, enabled: costApproachEnabled },
    { label: "Depreciated Cost of Improvements", width: 40.2, enabled: costApproachEnabled },
    { dataType: DATA_TYPE_STRING, label: "= $", source: "FN-429", enabled: costApproachEnabled },
  ],
  [
    { label: "Comments on Cost Approach (gross living area calculations, depreciation, etc.)", width: 50.3, style: { borderRight: 1 }, enabled: costApproachEnabled },
    { label: "\"As-is\" Value of Site Improvements", width: 40.2, enabled: costApproachEnabled },
    { dataType: DATA_TYPE_STRING, label: "= $", source: "FN-430", enabled: costApproachEnabled },
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, source: "FN-409-1|FN-409-2|FN-409-3|FN-409-4|FN-409-5|FN-409-6|FN-409-7", width: 50.3, style: { borderRight: 1 }, enabled: costApproachEnabled, hasValidationError: fieldRequiredValidator },
    { enabled: costApproachEnabled }
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Estimated Remaining Economic Life (HUD and VA only)", source: "FN-410", width: 46.2, hasValidationError: fieldRequiredValidator },
    { label: "Years", width: 4.1, style: { borderRight: 1 }, enabled: costApproachEnabled },
    { label: "Indicated Value By Cost Approach", width: 40.2, enabled: costApproachEnabled },
    { dataType: DATA_TYPE_STRING, label: "= $", source: "FN-431", enabled: costApproachEnabled, hasValidationError: fieldRequiredValidator },
  ],
  [
    { label: "Income", style: { className: DISPLAY_STYLE_HEADER } },
  ],
  [
    { label: "INCOME APPROACH TO VALUE (not required by Fannie Mae)", style: { className: DISPLAY_STYLE_SHADED } },
  ],
  [
    { dataType: DATA_TYPE_CHECKBOX, label: "Income Approach Required", source: "income-approach-required", dataTypeOptions: { checkedValue: "1", uncheckedValue: "0" } },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Estimated Monthly Rent $", source: "FN-432", width: 27.6, enabled: incomeApproachEnabled },
    { dataType: DATA_TYPE_STRING, label: "X Gross Rent Multiplier", source: "FN-433", width: 20.5, enabled: incomeApproachEnabled },
    { dataType: DATA_TYPE_STRING, label: "= $", source: "FN-434", width: 12, enabled: incomeApproachEnabled },
    { label: "Indicated Value by Income Approach", enabled: incomeApproachEnabled },
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, label: "Summary of Income Approach (including support for market rent and GRM)", source: "FN-435-1|FN-435-2", enabled: incomeApproachEnabled },
  ],
  [
    { label: "PUD Information", style: { className: DISPLAY_STYLE_HEADER } },
  ],
  [
    { label: "PROJECT INFORMATION FOR PUDs (if applicable)", style: { className: DISPLAY_STYLE_SHADED } },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Is the developer/builder in control of the Homeowners' Association (HOA)?", source: "FN-436|FN-437",
      dataTypeOptions: { options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }] },
      enabled: shouldBeEnabled
    },
    {
      dataType: DATA_TYPE_RADIO, label: "Unit type(s)", source: "FN-438|FN-439",
      dataTypeOptions: { options: [{ label: "Detached", value: "Detached" }, { label: "Attached", value: "Attached" }] },
      enabled: shouldBeEnabled
    },
  ],
  [
    { label: "Provide the following information for PUDs ONLY if the developer/builder is in control of the HOA and the subject property is an attached dwelling unit.", source: "Pud Section Label", enabled: shouldBeEnabled },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Legal name of project", source: "FN-441", enabled: shouldBeEnabled },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Total number of phases", source: "FN-442", width: 22.2, enabled: shouldBeEnabled },
    { dataType: DATA_TYPE_STRING, label: "Total number of units", source: "FN-443", width: 25.4, enabled: shouldBeEnabled },
    { dataType: DATA_TYPE_STRING, label: "Total number of units sold", source: "FN-444", enabled: shouldBeEnabled },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Total number of units rented", source: "FN-445", width: 22.2, enabled: shouldBeEnabled },
    { dataType: DATA_TYPE_STRING, label: "Total number of units for sale", source: "FN-446", width: 25.4, enabled: shouldBeEnabled },
    { dataType: DATA_TYPE_STRING, label: "Data Source(s)", source: "FN-447", enabled: shouldBeEnabled },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Was the project created by the conversion of an existing building(s) into a PUD?", source: "FN-448|FN-449", width: 51,
      dataTypeOptions: { options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }] },
      enabled: shouldBeEnabled
    },
    { dataType: DATA_TYPE_STRING, label: "If Yes, date of conversion", source: "FN-450", enabled: shouldBeEnabled },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Does the project contain any multi-dwelling units?", source: "FN-451|FN-452", width: 36,
      dataTypeOptions: { options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }] },
      enabled: shouldBeEnabled
    },
    { dataType: DATA_TYPE_STRING, label: "Data Source(s)", source: "FN-453", enabled: shouldBeEnabled },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Are the units, common elements, and recreation facilities complete?", source: "FN-454|FN-455", width: 45.1,
      dataTypeOptions: { options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }] },
      enabled: shouldBeEnabled
    },
    { label: "If No, describe the status of completion.", source: "Pud Completion Status Label", enabled: shouldBeEnabled },
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, source: "FN-456-1|FN-456-2|FN-456-3", enabled: shouldBeEnabled },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Are the common elements leased to or by the Homeowners' Association?", source: "FN-457|FN-458", width: 48,
      dataTypeOptions: { options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }] },
      enabled: shouldBeEnabled
    },
    { label: "If Yes, describe the rental terms and options.", source: "Pud Rental Terms Label", enabled: shouldBeEnabled },
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, source: "FN-459-1|FN-459-2", enabled: shouldBeEnabled },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Describe common elements and recreational facilities", source: "FN-460", enabled: shouldBeEnabled, hasValidationError: stringLengthValidator(110) },
  ],
  [
    {},
  ],
];
